import { render, staticRenderFns } from "./BuildTag.vue?vue&type=template&id=5c248144&"
import script from "./BuildTag.vue?vue&type=script&lang=js&"
export * from "./BuildTag.vue?vue&type=script&lang=js&"
import style0 from "./BuildTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports